import React from "react";
//#region types
import { PageFooterProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import useWizardContext from "./context/useWizardContext";
import PageFooter from "../pageFooter";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const WizardFooter: React.FC<PageFooterProps> = (props) => {
  const wizardContext = useWizardContext();

  return (
    <PageFooter
      {...props}
      onBackButtonClick={wizardContext?.currentStep ? wizardContext?.previous : undefined}
      onNextButtonClick={
        wizardContext && wizardContext.numOfSteps - 1 > wizardContext.currentStep ? wizardContext?.next : undefined
      }
      className={cssExports.wizardFooter}
      showHelp
    />
  );
};
export default WizardFooter;
